import React from "react";
import Rocket from "./models/Rocket";
import StarsAnimation from "./models/StarsAnimation";
import GradientBackground from "./models/GradientBackground";
import "./Scene.css";

export default function Scene() {
  return (
    <div className="scene-container">
      <GradientBackground />
      <StarsAnimation />
      <Rocket />
    </div>
  );
}
